<textarea class="form-control" rows="3" [(ngModel)]="content"></textarea>

<hr>

<p-footer>

  <button pButton class="p-button-success" icon="pi pi-check" label="Сохранить" (click)="onSubmit()"></button>

  <button pButton type="button" icon="pi pi-ban" class="p-button-secondary" label="Закрыть"
    (click)="onCancel()"></button>

</p-footer>
